module.exports = __webpack_public_path__ + "media/images/people/boy-12-3fd229dc1c536c73c91734735c4b7389.webp";